import { z } from "zod";

/** Lifecycle as the API derives it (inviteStatus). The UI adds "opened": pending with openedAt. */
export const INVITE_STATUSES = ["pending", "used", "expired", "revoked"] as const;

/**
 * One invite row as the management lists return it: the stored fields, the derived status, and
 * the decrypted link. `url` is null and `linkUnavailable` true when the token copy cannot be read.
 */
export const adminInviteRowSchema = z.object({
  id: z.string(),
  email: z.string(),
  workspaceId: z.string().nullable(),
  workspaceName: z.string().nullable(),
  role: z.string(),
  purpose: z.string(),
  expiresAt: z.string(),
  usedAt: z.string().nullable(),
  revokedAt: z.string().nullable(),
  openedAt: z.string().nullable(),
  status: z.enum(INVITE_STATUSES),
  url: z.string().nullable(),
  linkUnavailable: z.boolean(),
});
export type AdminInviteRow = z.infer<typeof adminInviteRowSchema>;

/**
 * Public peek for /invite/:token. Invalid, expired, used and revoked invites all answer
 * { valid: false }, so the response never says which one it was.
 */
export const invitePeekSchema = z.discriminatedUnion("valid", [
  z.object({ valid: z.literal(false) }),
  z.object({
    valid: z.literal(true),
    email: z.string(),
    workspaceName: z.string().nullable(),
    expiresAt: z.string(),
  }),
]);
export type InvitePeek = z.infer<typeof invitePeekSchema>;
